import settings from './settings';

const _logWarn = (message: string): void => {
    /* eslint-disable-next-line no-console */
    console.warn(message);
};

const _logError = (message: string): void => {
    /* eslint-disable-next-line no-console */
    console.error(message);
};

const _noop = (message: string): void => {
    /* Nothing to do */
};

export default Object.freeze({
    warn: settings.logging.isEnabled() ? _logWarn : _noop,
    error: settings.logging.isEnabled() ? _logError : _noop,
});
